const faShutterSpeed = {
  prefix: 'fal',
  iconName: 'shutter-speed',
  icon: [
    512,
    512,
    [],
    'e2df',
    'M188.8 56.9l0-35.6 134.4 0 0 35.6-134.4 0zm67.9 412.4q-40 0-75.1-15.2t-61.2-41.5-41.2-61.4-15.1-74.9q0-39.5 15.2-74.2t41.2-60.7 60.9-41 74.4-15q34.7 0 66.3 11.7t57.4 33.8l30.6-30.6 25.2 25.6-30.2 30.6q20.6 25.4 31.8 56.5T448 277.7q0 39.5-14.9 74.4t-40.9 60.9-60.9 41.2-74.6 15.2zm-.7-192zm-1.4-41.2l152.2 0q-10.3-35.2-34-62.6T315 132.3L254.6 236.1zM218 259.2l77.9-133.3q-35.7-9.1-72.1-2t-65.5 31.6L218 259.2zM101.7 300.4l117 0-75.7-131.6q-24.5 26.8-35.8 61.1t-5.4 70.5zm96.7 122.7l58.7-102.8-151.1 0q10.3 35.2 34.6 62t57.9 40.7zm19.9 5.7q36.3 9.1 71.6 1.5t63.8-30l-60.4-102.8-75 131.2zm150.4-42.3q24.2-27 36-60.7t6-69.8l-118.8 0 76.8 130.5z',
  ],
};
export default faShutterSpeed;
